export default "__VITE_ASSET__DP6Xn2DT__"